export default {
  guides: {
    home: "https://gt3dao.gitbook.io/cnkt",
    pwa: "https://gt3dao.gitbook.io/cnkt/guides/pwa",
  },
}
